<div class="flex flex-row md:flex-col py-1 pt-2 px-4 md:py-0 md:pt-0 md:px-0 bg-secondary-black">

    <!-- SEARCH -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Search" icon="search" iconClass="large-x"
        [displayName]="'Search'">
    </intello-navigation-link>

    <!-- CATEGORIES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Categories" icon="category" iconClass="medium"
        [displayName]="'Categories'">
    </intello-navigation-link>

    <!-- LANGUAGES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Languages" icon="language" iconClass="large-x"
        [displayName]="'Languages'">
    </intello-navigation-link>

    <!-- COURSES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Courses" icon="stack_single_round"
        iconClass="medium" [displayName]="'Courses'">
    </intello-navigation-link>

    <!-- MODULES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Modules" icon="circle_outline" iconClass="medium"
        [displayName]="'Modules'">
    </intello-navigation-link>

    <!-- LESSONS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Lessons" icon="packages" iconClass="medium"
        [displayName]="'Lessons'">
    </intello-navigation-link>

    <!-- GROUPS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Groups" icon="bookmark" iconClass="medium"
        [displayName]="'Groups'">
    </intello-navigation-link>

    <!-- FILES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Files" icon="file" iconClass="medium"
        [displayName]="'Files'">
    </intello-navigation-link>

    <!-- MINDPOPS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.ContentElements" iconClass="medium"
        icon="photo_library" [displayName]="'Mindpops'">
    </intello-navigation-link>

    <!-- HASHTAGS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Hashtags" iconClass="medium" icon="hashtag"
        [displayName]="'Hashtags'">
    </intello-navigation-link>

    <!-- FACTS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Facts" iconClass="medium" icon="linked"
        [displayName]="'Facts'">
    </intello-navigation-link>

    <!-- IDEAS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Ideas" icon="light_bulb" iconClass="medium"
        [displayName]="'Ideas'">
    </intello-navigation-link>

    <hr class="my-5 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10" />

    @if (authenticationService.isAuthenticated() && authenticationService.isAnyAdministrator()) {

    <!-- PRODUCTS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Products" icon="sell" iconClass="medium"
        [displayName]="'Products'">
    </intello-navigation-link>

    <!-- PRICES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Prices" icon="euro" iconClass="medium"
        [displayName]="'Prices'">
    </intello-navigation-link>

    <!-- AFFILIATES -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Affiliates" icon="handshake" iconClass="medium"
        [displayName]="'Affiliates'">
    </intello-navigation-link>

    <!-- CHANNELS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Channels" icon="photo_library" iconClass="medium"
        [displayName]="'Channels'">
    </intello-navigation-link>

    <!-- USERS -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Users" icon="groups" iconClass="medium"
        [displayName]="'Users'">
    </intello-navigation-link>

    <hr class="my-5 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10" />

    }

    <!-- ACCOUNT -->
    <intello-navigation-link class="w-1/6 md:w-full" [link]="AppRoutes.Account" icon="person" iconClass="medium"
        [displayName]="'My Account'">
    </intello-navigation-link>

</div>